import { loginCountPage } from "@/service/log";
import { formatMsgTime } from "@/utils/util";
export default {
  name: "WeekInDetail",
  data() {
    return {
      modal: {
        visible: false
      },
      list: []
    };
  },
  methods: {
    open(unitId) {
      this.modal.visible = true;
      this.getLoginCountPage(unitId);
    },
    /* 不显示弹窗 */
    clean() {
      this.modal.visible = false;
    },
    changeTime(loginTime) {
      return formatMsgTime(Date.parse(new Date(loginTime)));
    },
    async getLoginCountPage(unitId) {
      let params = {
        unitId,
        firstResult: 0,
        pageSize: 10
      };
      let res = await loginCountPage(params);
      if (res.data && res.data.result === 0) {
        this.list = res.data.retVal.datas;
      }
    }
  }
};